module.exports = __webpack_public_path__ + "img/zh.74e385f6.png";